import React from 'react';
import { AppState } from '../types';

type TabType = 'conception' | 'editing' | 'export';

interface StudioSidebarProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  appState: AppState;
  onSettingsClick: () => void;
}

export const StudioSidebar: React.FC<StudioSidebarProps> = ({
  activeTab,
  onTabChange,
  appState,
  onSettingsClick,
}) => {
  return (
    <nav className="w-16 bg-[#1e1e1e] border-r border-[#3f3f46] flex flex-col items-center py-4 shrink-0 z-30">
      <div className="w-10 h-10 bg-indigo-600 rounded-lg flex items-center justify-center text-white font-bold text-xl mb-8 shadow-lg shadow-indigo-600/30">J</div>
      <div className="flex flex-col space-y-6 w-full items-center">
        <button
          onClick={() => onTabChange('conception')}
          className={`group flex flex-col items-center justify-center gap-1 w-full relative transition-all ${activeTab === 'conception' ? 'text-indigo-400' : 'text-gray-500 hover:text-gray-300'}`}
        >
          {activeTab === 'conception' && <div className="absolute left-0 top-1/2 -translate-y-1/2 h-8 w-1 bg-indigo-600 rounded-r-full"></div>}
          <div className={`p-2 rounded-lg transition-colors relative ${activeTab === 'conception' ? 'bg-indigo-500/10' : 'group-hover:bg-gray-800'}`}>
            <span className="material-symbols-outlined text-2xl">design_services</span>
            {/* Loading badge when video is generating */}
            {appState === AppState.LOADING && (
              <span className="absolute -top-1 -right-1 w-3 h-3 bg-indigo-500 rounded-full animate-pulse" title="Génération en cours..." />
            )}
          </div>
          <span className="text-[9px] font-medium">Conception</span>
        </button>
        <button
          onClick={() => onTabChange('editing')}
          className={`group flex flex-col items-center justify-center gap-1 w-full relative transition-all ${activeTab === 'editing' ? 'text-indigo-400' : 'text-gray-500 hover:text-gray-300'}`}
        >
          {activeTab === 'editing' && <div className="absolute left-0 top-1/2 -translate-y-1/2 h-8 w-1 bg-indigo-600 rounded-r-full"></div>}
          <div className={`p-2 rounded-lg transition-colors ${activeTab === 'editing' ? 'bg-indigo-500/10' : 'group-hover:bg-gray-800'}`}>
            <span className="material-symbols-outlined text-2xl">movie_edit</span>
          </div>
          <span className="text-[9px] font-medium">Editing</span>
        </button>
        <button
          onClick={() => onTabChange('export')}
          className={`group flex flex-col items-center justify-center gap-1 w-full relative transition-all ${activeTab === 'export' ? 'text-indigo-400' : 'text-gray-500 hover:text-gray-300'}`}
        >
          {activeTab === 'export' && <div className="absolute left-0 top-1/2 -translate-y-1/2 h-8 w-1 bg-indigo-600 rounded-r-full"></div>}
          <div className={`p-2 rounded-lg transition-colors ${activeTab === 'export' ? 'bg-indigo-500/10' : 'group-hover:bg-gray-800'}`}>
            <span className="material-symbols-outlined text-2xl">high_quality</span>
          </div>
          <span className="text-[9px] font-medium">Upscale</span>
        </button>
      </div>
      <div className="mt-auto flex flex-col space-y-4 items-center mb-4">
        <button
          onClick={onSettingsClick}
          data-tour="settings-trigger"
          className="w-10 h-10 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 text-white flex items-center justify-center font-bold shadow-md text-sm cursor-pointer hover:scale-105 transition-transform group relative"
          title="Paramètres & Profil"
        >
          JK
          <div className="absolute inset-0 rounded-full ring-2 ring-white/20 group-hover:ring-white/40 transition-all"></div>
        </button>
      </div>
    </nav>
  );
};

export default StudioSidebar;
